import { cva, cx, type VariantProps } from 'class-variance-authority';

export const avatarCva = cva(
  [
    'inline-flex shrink-0 items-center justify-center overflow-hidden select-none group/avatar',
    'bg-primary-50',
    'font-medium text-neutral-900',
    'shadow-sm',
  ],
  {
    variants: {
      size: {
        sm: 'size-12 rounded-md text-headline-4 shadow-xs',
        '2xl': 'size-60 rounded-lg text-8xl shadow-md',
      },
      rounded: {
        true: 'rounded-full',
        false: '',
      },
    },
    defaultVariants: {
      size: 'sm',
      rounded: false,
    },
  },
);

export const imageCva = cx(
  'size-full object-cover opacity-0',
  'motion-safe:transition-opacity',
  'group-data-[status=loaded]/avatar:opacity-100',
  'group-data-[status=error]/avatar:hidden',
);

export type AvatarCva = VariantProps<typeof avatarCva>;
